<div class="chart-subtitle">
	<slot/>
</div>

<style>
	.chart-subtitle {
    margin-top: -6px;
	margin-bottom: 10px;
	color: #222222;
	font-weight: 600;
	font-size: 18px;
	}
</style>